import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ number, eyebrow, title, subtitle, light = false, align = "left" }) => (
  <div className={`${align === "center" ? "mx-auto text-center max-w-3xl" : "max-w-3xl"}`}>
    <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
      {number && (
        <span className="font-mono-tech text-xs sm:text-sm text-cyan-400/80">{number}</span>
      )}
      <span className="text-xs font-semibold uppercase tracking-[0.24em] text-cyan-300">{eyebrow}</span>
      <span className="h-px w-10 bg-gradient-to-r from-cyan-400/60 to-transparent" />
    </div>
    <h2 className={`font-display mt-4 text-2xl sm:text-3xl lg:text-[2.6rem] font-bold tracking-tight leading-tight ${light ? "text-white" : "text-white"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className="mt-4 text-base sm:text-lg text-slate-400 leading-relaxed">{subtitle}</p>
    )}
  </div>
);
